import {Dispatch} from "react";
import {changeIsReadOnlyMode, changePageId, changeTitle, changeType, changeUser, setPageWatermark} from "../reducers/app";
import {RequestPageType} from "../types/RequestPageType";
import {setNodes} from "../reducers/nodes";
import {NodeType, PageNode} from "../types/PageNode";
import UserService from "./User/UserService";
import {ApolloClient, NormalizedCacheObject} from "@apollo/client";
import { setTemplateModal } from "../reducers/modalSlice";
import { pageService } from "./Page/usePageService";
import { PageType } from "../types/Page";

// export const ComponentInitService = (pathId, isMobile, readOnlyMode, setLoaded, isMobilePreviewState) => {
export default class ComponentInitService {
    // let mainNode = useSelector((state) => state.nodes.present.value[0]);

    public static init(dispatch: Dispatch<any>, pathId: number, apolloClient: ApolloClient<NormalizedCacheObject>): Promise<PageType> {
        return new Promise((resolve, reject) => {
            pageService.fetch(pathId, apolloClient).then((page) => {
                if (page) {
                    //USER PART START
                    let userService = UserService.getInstance();
                    userService.init(apolloClient).then((result) => {
                        //TODO: Я не вижу тут проверки что пользователю вообще можно смотреть эту страницу
                        if (result.canEditPage(page.user.email, page.userAccesses, page.accessPageFolderDomainByPriority)) {
                            dispatch(changeIsReadOnlyMode(true));
                        } else {
                            dispatch(changeIsReadOnlyMode(false));
                        }
                        dispatch(changeUser(result.user))
                    }).catch(reason => {
                        reject(reason)
                    });
                    //USER PART END

                    //PAGE PART START
                    const { title, contentString, id, type } = page;

                    if (id) {
                        dispatch(changePageId(id));
                    }

                    if (type) {
                        dispatch(changeType(type))
                    }
                    const content = JSON.parse(contentString || "[]");
                    dispatch(setPageWatermark(page.pageWatermark ?? true))
                    if (content.length > 0) {
                        if (
                            type === RequestPageType.MobilePage &&
                            content[0]?.id === "1" &&
                            content[0]?.customStyle?.["max-width"] === "400px"
                        ) {
                            content[0].customStyle["max-width"] = "440px";
                        }
                        dispatch(setNodes({nodes: content}));
                        dispatch(changeTitle(page.title))
                    } else {
                        let initNode: PageNode = {
                            breadCrumbTitle: "Window",
                            type: NodeType.PageNode,
                            id: '1',
                            parentId: null,
                            tagName: 'div',
                            className: null,
                            nodes: [],
                            classes: []
                        }
                        if (type === RequestPageType.MobilePage) {
                            initNode.customStyle = {'max-width': '440px', 'margin': '0px auto'}
                            dispatch(setTemplateModal(true));
                        }
                        if(page?.title){
                            dispatch(changeTitle(page.title))
                        }
                        dispatch(setNodes({nodes: [initNode]}))
                    }
                    resolve(page)
                    //PAGE PART END
                }
            }).catch((reason) => {
                reject(reason)
            })
        })
    }

}
